// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3S1hk","colCheckbox":"styles_colCheckbox__2I7RI"};